import React from 'react';
import PropTypes from "prop-types";

import CryptoLinkCustomLabel
  from 'components/dashboard/crypto-links-content/CryptoLinkCustomLabel';
import CryptoLinkAddress
  from 'components/dashboard/crypto-links-content/CryptoLinkAddress';
import CryptoShowAsDropdown
  from 'components/dashboard/crypto-links-content/CryptoShowAsDropdown';
import CryptoLinkIsPublished
  from 'components/dashboard/crypto-links-content/CryptoLinkIsPublished';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './CryptoLinktemHeaderContent.css';


function CryptoLinktemHeaderContent(props) {
  const { item, deleteCryptoLink } = props;

  return (
    <div className="crypto-link-item-header-content__component">
      <div className="options-block">
        <div className="parameters">
          <div className="custom-label">
            <CryptoLinkCustomLabel linkItem={item} />
          </div>
          <div className="empty" />
        </div>

        <div className="parameters mobile-hidden">
          <div className="address">
            <CryptoLinkAddress
              key={`crypto-link-address-desktop-key-${item.id}`}
              linkItem={item}
              type="address"
              label={item.crypto_service.form_label}
            />
          </div>
          <div className="show-as">
            <CryptoShowAsDropdown
              key={`crypto-link-show-as-memo-desktop-key-${item.id}`}
              linkItem={item}
              parameter="display_mode"
            />
          </div>
        </div>

        {item.crypto_service.type === 'address_memo' &&
          <div className="parameters mobile-hidden">
            <div className="address">
              <CryptoLinkAddress
                key={`crypto-link-memo-desktop-key-${item.id}`}
                linkItem={item}
                type="memo"
                label={item.crypto_service.memo_name}
              />
            </div>
            <div className="show-as">
              <CryptoShowAsDropdown
                key={`crypto-link-show-as-memo-desktop-key-${item.id}`}
                linkItem={item}
                parameter="display_mode_memo"
              />
            </div>
          </div>
        }

      </div>

      <div className="actions-block mobile-hidden">
        <div className="delete">
          <CommonLinkDeleteButton
            key={`crypto-link-delete-icon-key-${item.id}`}
            linkItem={item}
            deleteFunction={deleteCryptoLink}
          />
        </div>
        <div className="is-published">
          <CryptoLinkIsPublished
            key={`crypto-link-is-published-key-${item.id}`}
            linkItem={item}
          />
        </div>
      </div>
    </div>
  );
}

CryptoLinktemHeaderContent.propTypes = {
  deleteCryptoLink: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default CryptoLinktemHeaderContent;
